module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Please sign in to Sephora',
        termsOfUseLink: 'Terms of Use',
        privacyPolicyLink: 'Privacy Policy'
    };

    return resources[label];
};
